import { Breadcrumb, Button, Card, Divider, Empty, Modal, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { useNavigate } from "react-router";
import Loader from "../../components/loader";
import moment from "moment";
import { amountFormat } from "../../services/common.service";
import successIcon from "../../assests/images/success.png";
import TransferService from "../../services/transfer.service";
import CommonOtp from "../../components/otp";
import PaymentService from "../../services/payments.service";
import { useTranslation } from "react-i18next";
import { ReactComponent as TitleIcon } from "../../assests/images/paymentbread.svg";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import ScheduledPaymentGrid from "../../components/scheduled-payments-grid";
import ScheduledPaymentList from "../../components/scheduled-payment-list";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function ScheduledPaymentsComponent() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [size, setSize] = useState(20);
  const [hasMoreRecords, setHasMoreRecords] = useState(false);
  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState({});
  const [serviceLoader, setServiceLoader] = useState(false);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [cancelled, setCancelled] = useState(false);
  const [resDetails, setResDetails] = useState({});
  const { t } = useTranslation();
  const [successVisible, setSuccessVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  const paymentTypes = {
    ONCE: t("pages.fundtransfer.one_time", {
      defaultValue: "One Time",
    }),
    RECURRING: t("common.recurring_si", { defaultValue: "Recurring SI" }),
    SCHEDULED: t("common.one_time_scheduled", {
      defaultValue: "One Time - Scheduled",
    }),
  };

  const transferTypes = {
    NEFT: t("common.neft_30min", { defaultValue: "NEFT(24X7) 30 min+" }),
    IMPS: t("common.imps_instant", { defaultValue: "IMPS Instant" }),
    RTGS: t("common.rtgs_instant", { defaultValue: "RTGS(24X7) Instant" }),
    IAT: t("pages.sendMoney.common_sendMoney.within_bank", {
      defaultValue: "Within Bank",
    }),
    ABC: "ABC",
  };

  useEffect(() => {
    setLoader(true);
    viewScheduledPayments(0, 1000);
  }, []);

  const viewScheduledPayments = useCallback(async (page, size) => {
    try {
      const response = await PaymentService.viewScheduledPayments({
        page: page,
        size: size,
      });
      if (response.status === 200) {
        setLoader(false);
        setDataSource(response.data["data"]);
        setHasMoreRecords(
          response.data["pagination"]["totalElements"] !==
            response.data["data"].length
        );
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  const fetchMoreTransactions = useCallback(() => {
    try {
      setLoader(true);
      setSize(size + 20);
      viewScheduledPayments(0, size + 20);
    } catch (error) {}
  }, [size]);

  const onVerify = useCallback(async (details) => {
    try {
      setServiceLoader(true);
      setDetails(details);
      const response =
        await PaymentService.modifyOrCancelScheduledPaymentVerify({
          id: details?.id,
          status: details?.scheduledStatus,
        });
      if (response.status === 200) {
        setServiceLoader(false);
        setOtpModalVisible(true);
      }
    } catch (error) {
      setServiceLoader(false);
    }
  }, []);

  const onConfirm = useCallback(async (details) => {
    try {
      setOtpModalVisible(false);
      const response =
        await PaymentService.modifyOrCancelScheduledPaymentConfirm({
          id: details?.id,
          status: details?.scheduledStatus,
          otp: details?.otp,
          enabledTOTP: details?.enabledTOTP,
        });
      if (response.status === 200) {
        setCancelled(true);
        setResDetails(response.data);
        setSuccessVisible(true);
      }
    } catch (error) {
      setServiceLoader(false);
      setOtp("");
    }
  }, []);

  return (
    <>
      <Breadcrumb separator=">" className="hide-xs">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/payment")}>
            {t("navigation.payments", {
              defaultValue: "Payments",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("pages.pay_bills.view_scheduled_payments", {
              defaultValue: "View Scheduled Payments",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-5%" }} /> */}
            <h3 className="title mb-0">
              {t("pages.pay_bills.view_scheduled_payments", {
                defaultValue: "View Scheduled Payments",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="application-card">
        {showGridAccount === "GRID" && (
          <ScheduledPaymentGrid
            dataSource={dataSource}
            hasMoreRecords={hasMoreRecords}
            setDetails={setDetails}
            setVisible={setVisible}
            fetchMoreTransactions={fetchMoreTransactions}
          />
        )}
        {showGridAccount === "LIST" && (
          <ScheduledPaymentList
            dataSource={dataSource}
            setDetails={setDetails}
            setVisible={setVisible}
            hasMoreRecords={hasMoreRecords}
            fetchMoreTransactions={fetchMoreTransactions}
          />
        )}
      </Card>
      <Modal
        title={""}
        open={visible}
        footer={null}
        width={750}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <h3 className="primary-title">
          {t("common.scheduled_payment_details", {
            defaultValue: "Scheduled Payment Details",
          })}
        </h3>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.accounts.accounts_common.source_account", {
                    defaultValue: "Source Account",
                  })}
                </span>
                <p className="value-receipt">{details?.srcAccount}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {" "}
                  {t("pages.pay_bills.consumer_id", {
                    defaultValue: "Consumer ID",
                  })}
                </span>
                <p className="value-receipt">{details?.consumerId || "-"}</p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("pages.pay_bills.biller_name", {
                    defaultValue: "Biller Name",
                  })}{" "}
                </span>
                <p className="value-receipt">{details?.billerName}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span>
                  {t("pages.accounts.accounts_common.amount", {
                    defaultValue: "Amount",
                  })}
                </span>
                <p className="value-receipt">
                  {amountFormat(details?.amount, details?.txnCcy)}
                </p>
              </div>

              {details?.referenceNo && (
                <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <span className="lbl-receipt">
                    {" "}
                    {t("pages.gepeg.ref_no", {
                      defaultValue: "Reference Number",
                    })}
                  </span>
                  <p className="value-receipt">{details?.referenceNo}</p>
                </div>
              )}

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("common.mobile_number", {
                    defaultValue: "Mobile Number",
                  })}
                </span>
                <p className="value-receipt">{details.mobileNo || "-"}</p>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("common.scheduled_date", {
                    defaultValue: "Scheduled Date",
                  })}{" "}
                </span>
                <p className="value-receipt">
                  {moment(details?.scheduledDate).format("DD-MM-YYYY")}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("common.created_date", { defaultValue: "Created Date" })}{" "}
                </span>
                <p className="value-receipt">
                  {moment(details?.createdDate).format("DD-MM-YYYY")}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("common.status", { defaultValue: "Status" })}{" "}
                </span>
                <p className="value-receipt">
                  {details?.scheduledStatus === "P"
                    ? t("pages.pending_approval.pending", {
                        defaultValue: "PENDING",
                      })
                    : details?.scheduledStatus}
                </p>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <span className="lbl-receipt">
                  {t("common.remarks", { defaultValue: "Reason" })}
                </span>
                <p className="value-receipt"> {details?.remarks || "-"}</p>
              </div>
            </div>
          </div>
        </div>

        <div align="right">
          <Button
            onClick={() => {
              setVisible(false);
              if (cancelled) {
                setDataSource([]);
                viewScheduledPayments(0, 1000);
              }
            }}
            className="secondary-btn"
            type="default"
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
          {!cancelled &&
            (details.scheduledStatus === "P" ||
              details.scheduledStatus === "PENDING") && (
              <Button
                onClick={(e) => {
                  onVerify(details);
                  setVisible(false);
                  e.stopPropagation();
                  e.preventDefault();
                }}
                className="mx-2"
                type="default"
                danger
              >
                {t("common.stop_payment", {
                  defaultValue: "Stop Payment",
                })}
              </Button>
            )}
        </div>
      </Modal>

      <Modal
        open={otpModalVisible}
        footer={null}
        width={600}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <CommonOtp
          otp={otp}
          setOtp={setOtp}
          onConfirm={(values) => onConfirm({ ...details, ...values })}
          handleResendOtp={() => onVerify(details)}
          cancelTransaction={() => {
            setOtp("");
            setOtpModalVisible(false);
          }}
        />
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{resDetails.message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/payment");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
